import logger from '@/modules/Logger';

export default {
  async reset() {
    try {
      this.localVideoTrack?.close();
      this.localAudioTrack?.close();
      this.rtc.localTracks.map(track => { track.close() });
      this.rtc.removeAllListeners();
      await this.rtc.leave();
    } catch (e) {
      logger.debug('[Agora] Error during reset', {
        operation: 'webrtc:reset',
        reason: e.message,
      });
    }
    this.localTracks = [];
    this.localAudioTrack = null;
    this.localVideoTrack = null;
  }
}
